import React, { FC, useMemo } from "react";
import { useLocalStorage } from "@utils/use-local-storage";
import { Branch } from "@ts-types/generated";

export interface State {
  branch: Branch | null;
}

const initialState = {
  branch: null,
};

type Action =
  | {
      type: "SET_BRANCH";
      payload: Branch | null;
    };

export const BranchContext = React.createContext<State | any>(initialState);

BranchContext.displayName = "BranchContext";

function branchReducer(state: State, action: Action) {
    switch (action.type) {
        case "SET_BRANCH": {
            return {
                ...state,
                branch: action.payload,
            };
        }
    }
};

export const BranchProvider: FC = (props) => {
  const [savedBranch, saveBranch] = useLocalStorage(
    'b_id',
    JSON.stringify(initialState)
  );
  const [state, dispatch] = React.useReducer(branchReducer, {
    ...JSON.parse(savedBranch!),
  });
  
  React.useEffect(() => {
    saveBranch(JSON.stringify(state));
  }, [state, saveBranch]);

  const setBranch = (branch: Branch) =>
    dispatch({ type: "SET_BRANCH", payload: branch });

  const value = useMemo(
    () => ({
      ...state,
      setBranch,
    }),
    [state]
  );

  return <BranchContext.Provider value={value} {...props} />;
};
  
  export const useBranch = () => {
    const context = React.useContext(BranchContext);
    if (context === undefined) {
      throw new Error(`useBranch must be used within a BranchProvider`);
    }
    return context;
  };
  